import UserRoles from "@/api/UserRoles";
import ReportOptions from "@/api/ReportOptions";
import BinderOptions from "@/api/BinderOptions";
import Report from "@/api/Report";
import Impersonate from "@/api/Impersonate";
import News from "@/api/News";
import HeaderInfo from "@/api/HeaderInfo";

class Manager {
  constructor() {
    this.userRoles = UserRoles;
    this.reportOptions = ReportOptions;
    this.binderOptions = BinderOptions;
    this.report = Report;
    this.impersonate = Impersonate;
    this.news = News;
    this.headerInfo = HeaderInfo;
  }
}

export default Manager;
